// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'

import ElementUI from 'element-ui';                      // 引入element-ui
import 'element-ui/lib/theme-chalk/index.css';  

import './assets/css/common.css';
import './assets/css/flex.css';
/* swiper */
import 'swiper/css/swiper.min.css';

import http from './api/http.js';

import store from './store/index.js';

Vue.use(ElementUI); 

Vue.prototype.http=http

Vue.prototype.$store=store

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js